module.exports = __webpack_public_path__ + "media/images/featuredon_medcitynews-f9db9af0.png";